import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Polyline, useMap } from 'react-leaflet';
import gpxParser from 'gpxparser';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Componente para ajustar el mapa automáticamente
const RecenterMap = ({ positions }) => {
  const map = useMap();
  useEffect(() => {
    if (positions.length > 0) {
      const bounds = L.polyline(positions).getBounds();
      map.fitBounds(bounds, { padding: [30, 30] });
    }
  }, [positions, map]);
  return null;
};

const ChallengeMap = () => {
  const [positions, setPositions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchGpx = async () => {
      console.log("LOG 1: Iniciando fetch...");
      try {
        const response = await fetch('/ruta.gpx');
        console.log("LOG 2: Status respuesta:", response.status);
        
        const gpxText = await response.text();
        console.log("LOG 3: Tamaño texto recibido:", gpxText.length);

        const gpx = new gpxParser();
        gpx.parse(gpxText);
        
        let coords = [];

        // Intento 1: Tracks
        if (gpx.tracks && gpx.tracks.length > 0 && gpx.tracks[0].points.length > 0) {
          console.log("LOG 4a: Encontrado en TRACKS");
          coords = gpx.tracks[0].points.map(p => [p.lat, p.lon]);
        } 
        // Intento 2: Routes
        else if (gpx.routes && gpx.routes.length > 0 && gpx.routes[0].points.length > 0) {
          console.log("LOG 4b: Encontrado en ROUTES");
          coords = gpx.routes[0].points.map(p => [p.lat, p.lon]);
        }
        // Intento 3: Waypoints
        else if (gpx.waypoints && gpx.waypoints.length > 0) {
          console.log("LOG 4c: Encontrado en WAYPOINTS");
          coords = gpx.waypoints.map(p => [p.lat, p.lon]);
        }

        console.log("LOG 5: Total puntos finales:", coords.length);
        
        if (coords.length > 0) {
          console.log("LOG 6: Primer punto:", coords[0]);
          setPositions(coords);
        } else {
          console.warn("LOG 6: No se extrajeron coordenadas. Revisa el formato del XML.");
        }

      } catch (error) {
        console.error("LOG ERROR:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchGpx();
  }, []);

  if (loading) return <div style={{ padding: '20px' }}>Cargando datos del GPX...</div>;

  return (
    <div style={{ height: '500px', width: '100%', border: '2px solid #ccc' }}>
      <MapContainer 
        center={[48.87, 2.77]} 
        zoom={5} 
        style={{ height: '100%', width: '100%' }}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; OpenStreetMap'
        />
        
        {positions.length > 0 && (
          <>
            <Polyline 
              positions={positions} 
              pathOptions={{ color: 'red', weight: 5, opacity: 0.7 }} 
            />
            <RecenterMap positions={positions} />
          </>
        )}
      </MapContainer>
    </div>
  );
};

export default ChallengeMap;